export default function PricingSection() {
  return (
    <section id="precios" className="py-20 bg-white dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200 rounded-full text-sm font-medium mb-4">
            PRECIOS TRANSPARENTES
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-6">
            Un precio justo para todos
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300">
            Sin costos ocultos, sin sorpresas. Todo incluido.
          </p>
        </div>

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {/* Free Trial */}
          <div className="relative bg-gradient-to-br from-blue-50 to-cyan-50 dark:from-blue-900/20 dark:to-cyan-900/20 rounded-3xl p-8 border-2 border-blue-200 dark:border-blue-700">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
              <span className="bg-gradient-to-r from-blue-600 to-cyan-600 text-white px-6 py-2 rounded-full text-sm font-semibold">
                POPULAR
              </span>
            </div>
            
            <div className="text-center mb-8">
              <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                Prueba Gratuita
              </h3>
              <div className="mb-4">
                <span className="text-5xl font-bold text-gray-900 dark:text-white">$0</span>
              </div>
              <p className="text-lg text-gray-600 dark:text-gray-300">
                30 días completos
              </p>
            </div>

            <ul className="space-y-4 mb-8">
              {[
                'Todas las características premium',
                'Sin límite de archivos',
                'Soporte por email',
                'Sin tarjeta de crédito',
                'Cancela cuando quieras'
              ].map((feature, index) => (
                <li key={index} className="flex items-center">
                  <i className="ri-check-line text-green-500 text-xl mr-3"></i>
                  <span className="text-gray-700 dark:text-gray-300">{feature}</span>
                </li>
              ))}
            </ul>

            <button className="w-full py-4 bg-gradient-to-r from-blue-600 to-cyan-600 text-white text-lg font-semibold rounded-xl hover:from-blue-700 hover:to-cyan-700 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer">
              Comenzar Gratis Ahora
            </button>
          </div>

          {/* Annual Plan */}
          <div className="relative bg-gradient-to-br from-purple-50 to-pink-50 dark:from-purple-900/20 dark:to-pink-900/20 rounded-3xl p-8 border-2 border-purple-200 dark:border-purple-700">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
              <span className="bg-gradient-to-r from-purple-600 to-pink-600 text-white px-6 py-2 rounded-full text-sm font-semibold">
                MEJOR VALOR
              </span>
            </div>
            
            <div className="text-center mb-8">
              <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                Plan Profesional
              </h3>
              <div className="mb-2">
                <span className="text-5xl font-bold text-gray-900 dark:text-white">$30</span>
                <span className="text-xl text-gray-600 dark:text-gray-300">/año</span>
              </div>
              <p className="text-lg text-purple-600 dark:text-purple-400 font-semibold">
                Solo $2.50 al mes
              </p>
            </div>

            <ul className="space-y-4 mb-8">
              {[
                'Todo de la prueba gratuita',
                'Actualizaciones prioritarias',
                'Soporte premium 24/7',
                'Almacenamiento cloud 100GB',
                'Sincronización ilimitada',
                'Acceso beta a nuevas funciones'
              ].map((feature, index) => (
                <li key={index} className="flex items-center">
                  <i className="ri-check-line text-yellow-500 text-xl mr-3"></i>
                  <span className="text-gray-700 dark:text-gray-300">{feature}</span>
                </li>
              ))}
            </ul>

            <button className="w-full py-4 bg-gradient-to-r from-purple-600 to-pink-600 text-white text-lg font-semibold rounded-xl hover:from-purple-700 hover:to-pink-700 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer">
              Suscribirse Ahora
            </button>
          </div>
        </div>

        {/* Payment Methods */}
        <div className="mt-16">
          <p className="text-center text-lg text-gray-600 dark:text-gray-300 mb-8">
            Aceptamos todos los métodos de pago
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            {/* PayPal */}
            <div className="text-center p-6 bg-gray-50 dark:bg-gray-800 rounded-xl">
              <div className="w-16 h-16 bg-blue-100 dark:bg-blue-900 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-paypal-line text-2xl text-blue-600 dark:text-blue-400"></i>
              </div>
              <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">PayPal</h4>
              <p className="text-sm text-gray-600 dark:text-gray-300 mb-3">
                Paga con tu cuenta PayPal o tarjeta de crédito/débito de forma segura
              </p>
              <span className="inline-block px-3 py-1 bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200 rounded-full text-xs">
                Más usado
              </span>
            </div>

            {/* Stripe */}
            <div className="text-center p-6 bg-gray-50 dark:bg-gray-800 rounded-xl">
              <div className="w-16 h-16 bg-purple-100 dark:bg-purple-900 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-bank-card-line text-2xl text-purple-600 dark:text-purple-400"></i>
              </div>
              <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">Tarjetas</h4>
              <p className="text-sm text-gray-600 dark:text-gray-300 mb-3">
                Visa, Mastercard, American Express con procesamiento Stripe seguro
              </p>
              <span className="inline-block px-3 py-1 bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 rounded-full text-xs">
                Más rápido
              </span>
            </div>

            {/* Other Methods */}
            <div className="text-center p-6 bg-gray-50 dark:bg-gray-800 rounded-xl">
              <div className="w-16 h-16 bg-green-100 dark:bg-green-900 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-wallet-line text-2xl text-green-600 dark:text-green-400"></i>
              </div>
              <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">Otros</h4>
              <p className="text-sm text-gray-600 dark:text-gray-300 mb-3">
                Apple Pay, Google Pay, transferencia bancaria y más
              </p>
              <span className="inline-block px-3 py-1 bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 rounded-full text-xs">
                Flexible
              </span>
            </div>
          </div>

          {/* Security Badges */}
          <div className="flex flex-wrap justify-center items-center gap-6 mt-8 pt-8 border-t border-gray-200 dark:border-gray-700">
            <div className="flex items-center text-sm text-gray-600 dark:text-gray-400">
              <i className="ri-lock-line text-green-500 mr-2"></i>
              Certificado SSL
            </div>
            <div className="flex items-center text-sm text-gray-600 dark:text-gray-400">
              <i className="ri-shield-check-line text-green-500 mr-2"></i>
              Encriptación 256-bit
            </div>
            <div className="flex items-center text-sm text-gray-600 dark:text-gray-400">
              <i className="ri-verified-badge-line text-green-500 mr-2"></i>
              PCI DSS Compliant
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}